import BaseService from './BaseService'
import { AD_PUBLISHING_CONNECT_BM_LOCATION } from '../util/constants'
class AdPublishingService extends BaseService {
  constructor(baseUrl: string) {
    super(baseUrl)
  }
  getPricingModel = (companyId:string) =>{
    return this.requests.get('/pricing-model', { params: { companyId } })
  }
  updatePricingModel = (companyId:string, type:string) => {
    return this.requests.post('/pricing-model', { companyId, type })
  }
  getCompanySubscription = (companyId:string, productCode?:string) => {
    return this.requests.get(`/reselling/subscription/company/${companyId}${productCode ? `?productCode=${productCode}` : ''}`)
  }
  getLocationSubscription = (locationId:string, productCode = AD_PUBLISHING_CONNECT_BM_LOCATION) => {
    return this.requests.get(`/reselling/subscription/location/${locationId}?productCode=${productCode}`)
  }
  getCompanyConfiguration = (companyId:string) => {
    return this.requests.get(`/reselling/configuration/company/${companyId}?productCode=${AD_PUBLISHING_CONNECT_BM_LOCATION}`)
  }
  updateCompanyConfiguration = (companyId:string, configuration:{amount:number}) => {
    return this.requests.put(`/reselling/configuration/company/${companyId}?productCode=${AD_PUBLISHING_CONNECT_BM_LOCATION}`, configuration)
  }
  getLocationConfiguration = (locationId:string, productCode=AD_PUBLISHING_CONNECT_BM_LOCATION) => {
    return this.requests.get(`/reselling/configuration/location/${locationId}?productCode=${productCode}`)
  }
  updateLocationConfiguration = (locationId:string, configuration:{amount?:number, offeringEnabled?:boolean}, productCode=AD_PUBLISHING_CONNECT_BM_LOCATION) => {
    return this.requests.put(`/reselling/configuration/location/${locationId}?productCode=${productCode}`, configuration)
  }
  agencyDirectPurchase = (locationId:string, productCode=AD_PUBLISHING_CONNECT_BM_LOCATION, payload = {}) => {
    return this.requests.post(`/reselling/subscription/location/${locationId}?productCode=${productCode}`, payload)
  }

  async getAdwords(locationId: string){
    const data = await this.requests.get(`/google/conversions?locationId=${locationId}`)
    return data;
  }
}

const adPublishingService = new AdPublishingService(
    BaseService.servicesConfig.AdPublishingService as string
  )
export default adPublishingService